import { FsDataDogRumService } from '@lib/data-dog-rum';

import { StreamContext } from '../services';

export interface StreamErrorParams {
  datadogService: FsDataDogRumService;
  cameraId: string;
  protocol: 'hls' | 'flv' | 'sldp' | 'html5' | 'websocket' | 'unknown';
  sourceUi: string;
  errorType: string;
  rawError: string;
  errorCode: string | number;
  isLive: boolean;
  isFatal: boolean;
  timestamp?: number;
  streamUrl?: string;
  context?: StreamContext;
  protocolSpecificFields?: {
    error_details?: string;
    error_source?: 'video_element' | 'websocket' | 'timeout';
    websocket_close_code?: number;
    websocket_close_reason?: string;
    media_error_code?: number;
    media_error_message?: string;
    hls_error_type?: string;
    hls_error_details?: string;
    hls_fatal?: boolean;
    hls_buffer_stalled?: boolean;
    hls_current_level?: number;
    hls_stream_recovering?: boolean;
    flv_error_type?: string;
    /**
     * FLV error details from flv.js. Can be any type (string, object, etc.)
     * Will be automatically converted to string via JSON.stringify if not already a string.
     */
    flv_error_details?: unknown;
  };
}

export function emitStreamError(params: StreamErrorParams): void {
  const {
    datadogService,
    cameraId,
    protocol,
    sourceUi,
    errorType,
    rawError,
    errorCode,
    isLive,
    isFatal,
    timestamp = Date.now(),
    streamUrl,
    context,
    protocolSpecificFields = {},
  } = params;

  const errorCodeValue = typeof errorCode === 'number' ? errorCode : errorCode || 'UNKNOWN';

  const processedProtocolFields: {
    error_details?: string;
    error_source?: 'video_element' | 'websocket' | 'timeout';
    websocket_close_code?: number;
    websocket_close_reason?: string;
    media_error_code?: number;
    media_error_message?: string;
    hls_error_type?: string;
    hls_error_details?: string;
    hls_fatal?: boolean;
    hls_buffer_stalled?: boolean;
    hls_current_level?: number;
    hls_stream_recovering?: boolean;
    flv_error_type?: string;
    flv_error_details?: string;
  } = {
    ...protocolSpecificFields,
    flv_error_details:
      protocolSpecificFields?.flv_error_details !== undefined
        ? typeof protocolSpecificFields.flv_error_details === 'string'
          ? protocolSpecificFields.flv_error_details
          : JSON.stringify(protocolSpecificFields.flv_error_details)
        : undefined,
  };

  datadogService.addAction('stream_error', {
    ...(context || {}),
    timestamp,
    camera_id: cameraId,
    source_ui: sourceUi,
    protocol,
    error_type: errorType,
    raw_error: rawError,
    error_code: errorCodeValue,
    is_live: isLive,
    is_fatal: isFatal,
    ...(streamUrl && { stream_url: streamUrl }),
    ...processedProtocolFields,
  });
}
